//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "ModalClubBetOptinPopup",

  props: {
    show: { type: Boolean, default: false },
    title: { type: String, default: '¡Disculpa!' },
    message: { type: String, default: '' },
    bottomText: { type: String, default: '' },
    titleColor: { type: String, default: 'text-primary'},
    topImage: {
      type: String,
      default: '/images/promotion-events/email-banner.jpg'
    },
    modalAction: {
      type: String,
      default: "optin-to-club-bet",
    },
    showButton: { type: Boolean, default: false },
    buttonActionText: { type: String, default: '' },
    termsHtml: "",
  },
  methods: {
    handleClose() {
      this.$emit("close-popup");
    },
    handleAction() {
      this.$emit("action-popup", this.modalAction);
    }
  }
}
